var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-4"},[_c('h1',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('CONTENT.aboutPage.about')))]),_c('div',{staticClass:"about__block p-6"},[_c('p',{staticClass:"pb-4"},[_vm._v(_vm._s(_vm.$t('CONTENT.aboutPage.copyright')))]),_c('p',{staticClass:"pb-4"},[_vm._v(_vm._s(_vm.$t('CONTENT.aboutPage.registration')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }